<template lang="html">

  <div class="contenedor-tarifas">

    <article class="tarifa-el -solar" id="CEprecioFijo" v-if="getTarifasLuz('cocheElectrico') && (tarifaActiva == 'CEprecioFijo' || tarifaActiva == null)">

      <div class="nombre-tarifa container">
        <figure>1</figure>
        <h2>
          <span class="-purple">{{ $t('tarifasLuz.tarifas.hogar.coche_electrico["CEprecioFijo"].title') }}</span>
          <span class="-orange">{{ $t('tarifasLuz.tarifas.hogar.coche_electrico["CEprecioFijo"].subtitle') }}</span>
          <img src="/static/img/sello.svg" class="sello-recomendada">
        </h2>
      </div>

      <div class="contenedor-intro-tarifa row-center inside-picture">
        <div class="textos container">
          <div class="contenedor-textos">
            <h3 class="-orange">{{ $t('tarifasLuz.tarifas.hogar.coche_electrico["CEprecioFijo"].claim') }}</h3>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.coche_electrico["CEprecioFijo"].objetive1') }}</h5>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.coche_electrico["CEprecioFijo"].objetive2') }}</h5>
          </div>
        </div>

        <img src="/static/img/bg-coche-electrico.webp" class="img-tarifa">

        <img src="/static/img/figuras-naranjas.svg" class="figuras-naranjas">

      </div>

      <div class="contenedor-boton" v-show="!showpreciosDHA">

        <a @click="showpreciosDHA = true" class="btn -degree">{{ $t('quieroEstaTarifa') }}</a>

      </div>

      <seleccion-precio-tarifa :how="'DHA'" :type="'cocheElectrico' " :priceType="'fixed'"></seleccion-precio-tarifa>

    </article>

    <article class="tarifa-el -solar" id="CEprecioCoste" v-if="getTarifasLuz('cocheElectrico') && (tarifaActiva == 'CEprecioCoste' || tarifaActiva == null)">

      <div class="nombre-tarifa container">
        <figure>2</figure>
        <h2>
          <span class="-purple">{{ $t('tarifasLuz.tarifas.hogar.coche_electrico["CEprecioCoste"].title') }}</span>
          <span class="-orange">{{ $t('tarifasLuz.tarifas.hogar.coche_electrico["CEprecioCoste"].subtitle') }}</span>
        </h2>
      </div>

      <div class="contenedor-intro-tarifa row-center inside-picture">
        <div class="textos container">
          <div class="contenedor-textos">
            <h3 class="-orange">{{ $t('tarifasLuz.tarifas.hogar.coche_electrico["CEprecioCoste"].claim') }}</h3>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.coche_electrico["CEprecioCoste"].objetive1') }}</h5>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.coche_electrico["CEprecioCoste"].objetive2') }}</h5>
          </div>
        </div>

        <img src="/static/img/bg-coche-electrico2.webp" class="img-tarifa object-top">

        <img src="/static/img/figuras-naranjas.svg" class="figuras-naranjas">

      </div>

      <div class="contenedor-boton" v-show="!showpreciosDHA">

        <a @click="showpreciosDHA = true" class="btn -degree">{{ $t('quieroEstaTarifa') }}</a>

      </div>

      <seleccion-precio-tarifa :how="'DA'" :type="'CEprecioCoste'" :priceType="'index'"></seleccion-precio-tarifa>

    </article>
  </div>

</template>

<script lang="js">

import seleccionPrecioTarifa from '@/components/parts/selector-precio-tarifa';

import { mapGetters } from 'vuex';

export default {
  name: 'tarifas-menos',
  props: ['tarifaActiva'],
  data() {
    return {
      showpreciosDA: true,
      showpreciosDHA: true,
    }
  },
  components: {
    'seleccion-precio-tarifa': seleccionPrecioTarifa
  },
  computed: {
    ...mapGetters({
      horario: 'gethorario',
      precios: 'getPrecios'
    })
  },
  methods: {
    getTarifasLuz(type) {
      if (!!this.precios) {
        return this.precios.tarifas_luz[type];
      }
    }
  },
  watch: {
    tarifaActiva(newTarifa) {
      if (!newTarifa) return;

      this.$nextTick(() => {
        const section = document.getElementById('botonera-tarifas');
        if (section) {
          const header = document.querySelector('.header');
          const headerHeight = header ? header.offsetHeight : 0;
          const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;

          window.scrollTo({
            top: Math.max(sectionTop - headerHeight, 0),
            behavior: 'smooth'
          });
        }
      });
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/luz/tarifas-coche.vue